/* eslint-disable @typescript-eslint/no-unused-vars */
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, Snackbar, SnackbarCloseReason, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useEffect, useState } from 'react';
import { IAplicacao, IConta, IDisponivel, RelatorioFinanceiroService } from '../../../shared/services/api/Financeiro/Relatorios';

export const Disponivel: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [rowsconta, setRowsConta] = useState<IConta[]>([]);
  const [rowsaplicacao, setRowsAplicacao] = useState<IAplicacao[]>([]);
  const [saldototalConta, setSaldoTotalConta] = useState(0);
  const [saldototalAplicacao, setSaldoTotalAolicacao] = useState(0);

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };

  useEffect(() => {
    setIsLoading(true);
    RelatorioFinanceiroService
      .Disponivel()
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setRowsConta(result.conta);
          setSaldoTotalConta(result.conta[0].saldo_total);
          setRowsAplicacao(result.aplicacao);
          setSaldoTotalAolicacao(result.aplicacao[0].saldo_total);
        }
      });
  }, []);

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} display="flex" alignItems="center" alignSelf='center' width='auto' height="auto" margin={1} alignContent='center'></Box>
      <Box width='auto' alignItems="center" component={Paper} height="auto" 
        alignContent='center'>
        <DialogTitle>Disponivel</DialogTitle>
        <Grid container item direction="row" spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <DialogTitle align='right' style={{ color: saldototalConta > 0 ? 'inherit' : '#db4a39' }} >Saldo Geral:  {saldototalConta.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</DialogTitle>
            <DialogContent dividers>
              <TableContainer component={Paper} variant="outlined" sx={{ width: 'auto', height: 610, maxHeight: 610 }}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: '#5E8A71' }} aria-label="a dense table">
                    <TableRow >
                      <TableCell style={{ color: '#fff' }} align='left'>Descrição</TableCell>
                      <TableCell style={{ color: '#fff' }} align='right'>Agencia</TableCell>
                      <TableCell style={{ color: '#fff' }} align='center'>Conta</TableCell>
                      <TableCell style={{ color: '#fff' }} align='right'>Saldo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsconta.map(row => (
                      <TableRow key={row.idconta}
                        hover
                        sx={{ cursor: 'pointer', '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell  >{row.nomebanco}</TableCell>
                        <TableCell  >{row.agencia}</TableCell>
                        <TableCell  >{row.numeroconta}</TableCell>
                        <TableCell style={{ color: row.saldo > 0 ? 'inherit' : '#db4a39' }} align='right' >{row.saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    {isLoading && (
                      <TableRow>
                        <TableCell colSpan={9}>
                          <LinearProgress variant='indeterminate' />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableFooter>
                </Table>
              </TableContainer>
            </DialogContent>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <DialogTitle align='right' style={{ color: saldototalAplicacao > 0 ? 'inherit' : '#db4a39' }} >Saldo Geral:  {saldototalAplicacao.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</DialogTitle>
            <DialogContent dividers>
              <TableContainer component={Paper} variant="outlined" sx={{ width: 'auto', height: 610, maxHeight: 610 }}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: '#5E8A71' }} aria-label="a dense table">
                    <TableRow >
                      <TableCell style={{ color: '#fff' }} align='left'>Descrição</TableCell>
                      <TableCell style={{ color: '#fff' }} align='right'>Agencia</TableCell>
                      <TableCell style={{ color: '#fff' }} align='center'>Conta</TableCell>
                      <TableCell style={{ color: '#fff' }} align='right'>Saldo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsaplicacao.map(row => (
                      <TableRow key={row.idconta}
                        hover
                        sx={{ cursor: 'pointer', '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell  >{row.nomebanco}</TableCell>
                        <TableCell  >{row.agencia}</TableCell>
                        <TableCell  >{row.numeroconta}</TableCell>
                        <TableCell style={{ color: row.saldo > 0 ? 'inherit' : '#db4a39' }} align='right' >{row.saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    {isLoading && (
                      <TableRow>
                        <TableCell colSpan={9}>
                          <LinearProgress variant='indeterminate' />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableFooter>
                </Table>
              </TableContainer>
            </DialogContent>
          </Grid>
        </Grid>
      </Box >
    </Box >
  );
};   